import mixpanel from 'mixpanel-browser'
import { MIXPANEL_TOKEN } from './constants'

mixpanel.init(MIXPANEL_TOKEN, { persistence: 'localStorage' })

const getClickIdFromCookie = () => {
  const name = 'i_clickId='
  const cookies = document.cookie.split(';').map(cookie => cookie.trim())
  const match = cookies.find(cookie => cookie.startsWith(name))
  return match ? decodeURIComponent(match.substring(name.length)) : null
}

const clickId = getClickIdFromCookie()
if (clickId) {
  mixpanel.identify(clickId)
}

const getBaseProperties = () => ({
  page_name: 'my_account',
  Page: 'my_account',
  language: document.documentElement.lang || 'en',
  Channel: 'Intego Website',
  'Initial channel': 'Intego Website',
  media_source: 'direct',
  mo: 'no',
  clickID: clickId || '',
})

export const trackPageView = (pageName) => {
  mixpanel.track('Page View', {
    ...getBaseProperties(),
    page_name: pageName,
    Page:      pageName,
  })
}

export const trackObjectClicked = (object, extraProperties = {}) => {
  mixpanel.track('website_object_clicked', {
    ...getBaseProperties(),
    event:  'website_object_clicked',
    object,
    ...extraProperties,
  })
}

export default mixpanel